import { useEffect } from 'react';
import React from 'react';
import { useNavigate } from 'react-router';

export const PainelVendedor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/vendedor/orcamento');
  });

  return <></>;
};

export default PainelVendedor;
